import { SeverityLevel, captureMessage } from '@sentry/nextjs'

import { isProduction } from 'lib/utils/environments'

const productionLogger = () => {
  const log = (message, severity: SeverityLevel) =>
    captureMessage(JSON.stringify(message), severity)
  return {
    info: message => {
      log(message, 'info')
    },
    debug: message => {
      log(message, 'debug')
    },
    warn: message => {
      log(message, 'warning')
    },
    error: (message, ...optionalParams: unknown[]) => {
      log({ message, ...optionalParams }, 'error')
    }
  }
}

const developmentLogger = () => {
  return {
    info: message => {
      console.info(message)
    },
    debug: message => {
      console.debug(message)
    },
    warn: message => {
      console.warn(message)
    },
    error: (message, ...optionalParams: unknown[]) => {
      console.error(message, ...optionalParams)
    }
  }
}

const getLogger = () =>
  isProduction ? productionLogger() : developmentLogger()

const logger = getLogger()

export default logger
